import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pop-up-message-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { class: "description-wrapper" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "star-wrapper" }
const _hoisted_7 = { class: "wks-open-input-wrapper" }

import { ref, onBeforeMount, onUnmounted, watch, toRefs } from 'vue'
import { IonContent, IonPage } from "@ionic/vue";
import PopUpMask from '@/modules/a.worksheets/views/components/feedback/PopUpMask.vue'
import router from '@/router';
import { getComputedPageLayout, getIcon } from '@/helpers/api';
import StarRating from '@/modules/a.worksheets/views/components/StarRating.vue';
import WksOpenInput from '@/modules/a.worksheets/views/components/footer/WksOpenInput.vue';
import { createMemoryHistory } from 'vue-router';
import { SolutionData, useWorksheetHandler } from '@/globals/helpers/worksheetHandler';
import { worksheetService } from '@/modules/a.worksheets/services/worksheet.service';
import { useModalManager, Wks_Modals } from '@/modules/a.worksheets/services/modalManager';
import { useDeviceStatus } from '@/stores/deviceStatus';

interface _1614A {
    labels: {
        title: string, lines: Array<string>, button: string, next: string,
    },
    helps: {
        msg: string
    }
}




export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  setup(__props) {

const { isWeb } = toRefs(useDeviceStatus());

const mediaButton = ref<Array<any>>([])

const icon = ref<string>()
const layout = getComputedPageLayout<_1614A>('1614A')
onBeforeMount(async () => {
    icon.value = await getIcon('1614A', 'icon')

    // const photo = await createBtn('photo', true)
    // if(photo) mediaButton.value.push(photo)
    
    // const audio = await createBtn('audio', true)
    // if(audio) mediaButton.value.push(audio)


})

const rating = ref<number>(0)



async function createBtn(type: 'audio' | 'document' | 'photo' | 'video' | 'expand' | 'pdf', isEnabled: boolean | undefined): Promise<undefined | any> {
  if (isEnabled) {
    const resolvedSrc = await getIcon("1602", type)
    return {
      src: resolvedSrc ?? '',
      route: btnRoutes[type],
      name: type === 'expand' ? 'text' : type
    }
  }
}

const btnRoutes = {
  photo: 'worksheet-take-photos',
  video: 'worksheet-take-videos',
  audio: 'worksheet-take-audios',
  document: 'worksheet-upload-document',
  pdf: 'worksheet-upload-pdf',
  expand: 'text-editor',
}

function close() {
    router.back()
}

const wh = useWorksheetHandler()
async function catchFeedback(data: string | File[], type: SolutionData){
    const response = await sendFeedback(wh.wksAnsUUID.value, data, type)
}

const modalManager = useModalManager()

async function sendFeedback(user_wks_status: string, data: string | File[], type: SolutionData){
    let stringVal = ''
    let fileArr: Array<File> = []

    if(typeof data === 'string'){
        stringVal = data
    }else{
        fileArr = data
    }
    const response = await worksheetService.postFeedback(user_wks_status, rating.value, stringVal, fileArr)

    if(response.status === 200){
        modalManager.open(Wks_Modals.FEEDBACK_SUCCESS)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(PopUpMask, null, {
              icon: _withCtx(() => [
                _createElementVNode("img", { src: icon.value }, null, 8, _hoisted_2)
              ]),
              title: _withCtx(() => [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(layout)?.labels.title), 1)
              ]),
              description: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(layout)?.labels.lines, (line, key) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: key,
                      innerHTML: line
                    }, null, 8, _hoisted_5))
                  }), 128)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(StarRating, {
                      rating: rating.value,
                      "onUpdate:rating": _cache[0] || (_cache[0] = ($event: any) => ((rating).value = $event))
                    }, null, 8, ["rating"])
                  ])
                ])
              ]),
              button: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(WksOpenInput, {
                    "media-button": mediaButton.value,
                    placeholder: _unref(layout)?.helps.msg,
                    onSetMedia: catchFeedback
                  }, null, 8, ["media-button", "placeholder"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})